import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Box: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexShrink: 0,
    position: 'relative',
  },
  BoxBtn: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '28px',
  },
  BoxHeader: {
    zIndex: 999999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    alignSelf: 'stretch',
    position: 'fixed',
    borderBottom: '1px solid var(--Gray-200, #EAECF0)',
    background: '#FFF',
    height: '72px',
    width: '-webkit-fill-available',
    padding: '0 24px',
  },
  BoxContent: {
    width: '-webkit-fill-available',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '24px',
    flex: '1 0 0',
    padding: '16px',
    marginTop: '72px',
    borderBottom: '1px solid var(--Gray-200, #EAECF0)',
    background: 'var(--Gray-50, #F9FAFB)',
    paddingBottom: '150px',
  },
  BoxFooter: {
    display: 'flex',
    padding: '16px',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '12px',
    width: '70%',
    boxShadow: '0px -4px 8px -2px rgba(16, 24, 40, 0.10), 0px -2px 4px -2px rgba(16, 24, 40, 0.06)',
    position: 'fixed',
    background: '#FFF',
    bottom: 0,
  },
  LeftHeaderBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  IconClose: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    padding: '8px',
    border: '1px solid var(--Gray-300, #D0D5DD)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  },
  BoxItemInformation: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px 16px 0px 16px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: '#FFF',
  },
  ProductCard: {
    display: 'flex',
    paddingBottom: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  BoxInformationEachItem: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
  },
  BoxAddCustomizeGroupSettings: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
  },
  BoxGroupOption: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',
    gap: '8px',
  },
}));

const buttonAddStyle = {
  display: 'flex',
  padding: '16px 28px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Primary-600, #30893C)',
  background: 'var(--Primary-600, #30893C)',
  width: '100%',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: 'var(--Primary-600, #30893C)' },
};

const buttonRemoveStyle = {
  display: 'flex',
  padding: '16px 28px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Error-50, #FEF3F2)',
  background: 'var(--Error-50, #FEF3F2)',
  '&:hover': { backgroundColor: 'var(--Error-50, #FEF3F2)' },
  width: '100%',
};

const buttonAddCustomizeSetting = {
  display: 'flex',
  padding: '10px 16px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  '&:hover': { backgroundColor: 'var(--Primary-600, #30893C)' },
  borderRadius: '6px',
  border: '1px solid var(--Primary-600, #30893C)',
  background: 'var(--Primary-600, #30893C)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
};

export { useStyles, buttonAddStyle, buttonRemoveStyle, buttonAddCustomizeSetting };
